import React, { ReactElement } from 'react';

import TDropdownFooterProps from './types/TCustomDropdownFooterProps';
import componentName from './name';
import Box from '../Box/Box';
import InputError from '../InputError';

const CustomDropdownFooter = ({ errorText }: TDropdownFooterProps): ReactElement => (
  <Box parent={componentName} name="footer" as="footer">
    <InputError errorText={errorText} />
  </Box>
);

export default CustomDropdownFooter;
